(() => {
  const bindPolicies = () => {
    document.querySelectorAll('[data-sf-policy-open]').forEach(link => {
      if (link.dataset.bound) return;
      link.dataset.bound = 'true';
      link.addEventListener('click', event => {
        const dialog = document.getElementById(link.dataset.sfPolicyOpen);
        if (dialog?.showModal) { event.preventDefault(); dialog.showModal(); }
      });
    });
    document.querySelectorAll('[data-sf-policy-close]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => button.closest('dialog').close());
    });
  };
  const syncCart = async () => {
    const script = document.querySelector('[data-sf-navigation]');
    if (!script) return;
    try {
      const response = await fetch(script.dataset.cartUrl, {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-sf-cart-count]').forEach(count => {count.textContent = cart.item_count;count.hidden = !cart.item_count && !count.hasAttribute('data-sf-cart-count-always');});
    } catch {}
  };
  bindPolicies();
  document.addEventListener('shopify:section:load', bindPolicies);
  window.addEventListener('pageshow', syncCart);
  document.addEventListener('sfo:cart-updated', syncCart);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, syncCart);
})();

